export default "__VITE_ASSET__27fe89e0__"